export default {
  computed: {
    fleetTaskInstantFields() {
      const fields = [
        {
          label: this.$t('global.field.fleetTaskNumber'),
          key: 'number',
          isRedirectable: true,
          hasOpenNewTab: true,
          isSortable: true,
          isLocked: true,
          tdAttr: {
            style: 'width:140px',
          },
          thAttr: {
            style: 'width:140px',
          },
        },
        {
          label: 'Status',
          key: 'status.name',
          isSortable: true,
          isLocked: true,
        },
        {
          label: this.$t('global.field.licensePlate'),
          key: 'vehicle.license_plate',
          isSortable: true,
          isLocked: true,
        },
        {
          label: this.$t('global.field.driver'),
          key: 'driver.name',
          isSortable: false,
        },
        {
          label: this.$t('global.field.createdDate'),
          key: 'created_on',
        },
        {
          label: this.$t('global.field.tracking'),
          key: 'track_fo',
          isSortable: false,
          isLocked: true,
          isSticky: true,
          tdAttr: {
            style: 'right:-30px;position:sticky;border-left:1px solid #e6e7ec',
          },
          thAttr: {
            style: 'right:-30px;position:sticky;z-index:1;border-left:1px solid #e6e7ec',
          },
        }
      ]

      if (!this.hasFleetTaskInstantScope) {
        fields.splice(5, 0, {
          label: this.$t('global.field.driverDocument'),
          key: 'driver_attachment',
          isSortable: false,
        })
      }

      return fields
    },
  },
}
